import { render, staticRenderFns } from "./FormInputCheckbox.vue?vue&type=template&id=60647d7e&"
import script from "./FormInputCheckbox.vue?vue&type=script&lang=js&"
export * from "./FormInputCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports